import React from "react";
import { RadioButtonWrapper } from "./style";

export const RadioButton = props => {
  return (
    <RadioButtonWrapper select={props.select} onClick={() => props.onSelect && props.onSelect()}>{props.label}</RadioButtonWrapper>
  );
};
